export function getImageUrl(
    imageUrl: string | undefined,
    baseUrl: string | undefined
): string {
    if (!imageUrl) return "";

    const trimmed = imageUrl.trim();
    if (
        trimmed.startsWith("http://") ||
        trimmed.startsWith("https://") ||
        trimmed.startsWith("//")
    ) {
        return trimmed;
    }

    if (!baseUrl) {
        return trimmed;
    }

    const origin = baseUrl.replace(/\/$/, "");
    const path = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
    return `${origin}${path}`;
}

export function getMobileImageUrl(
    image: { mobile?: { url?: string } } | undefined,
    baseUrl: string | undefined
): string {
    return getImageUrl(image?.mobile?.url, baseUrl);
}

export function getDesktopImageUrl(
    image: { desktop?: { url?: string } } | undefined,
    baseUrl: string | undefined
): string {
    return getImageUrl(image?.desktop?.url, baseUrl);
}
